import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './PlatformBadges.css';

const {
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMusic
}=FiIcons;

export const platformDetails={
  instagram:{label:'Instagram',icon:FiInstagram},
  facebook:{label:'Facebook',icon:FiFacebook},
  linkedin:{label:'LinkedIn',icon:FiLinkedin},
  tiktok:{label:'TikTok',icon:FiMusic}
};

function PlatformBadges({platforms=[],compact=false}) {
  if (!platforms.length) {
    return null;
  }

  return (
    <span
      className={`platform-badges ${compact ? 'compact' : ''}`}
      aria-label={`Published to ${platforms.map(
        (id)=> platformDetails[id]?.label || id
      ).join(', ')}`}
    >
      {platforms.map((id)=> {
        const platform=platformDetails[id];

        if (!platform) {
          return null;
        }

        return (
          <span
            className="platform-badge"
            key={id}
            title={platform.label}
          >
            <SafeIcon icon={platform.icon} />
          </span>
        );
      })}
    </span>
  );
}

export default PlatformBadges;